import React from 'react'

/* Style */
import './TopBar.css'

/**
 * Images
 */
import logo from '../img/logo.jpg'

/* Modules */
import { Link } from 'react-router-dom'

const TopBarView = (props) => {
    return (
        <div className='TopBarBody'>
            <div className='TopBarContent'>
                <Link to={{ pathname: '/' }}>
                    <div style={{ width: '5%', float: 'left', marginTop: '10px', marginLeft: '15px' }}>
                        <img src={logo} alt={"logo"} width="30" height="30" />
                    </div>
                </Link>

                <Link to={{ pathname: '/' }}>
                    <div className='TopBarLink' style={{ color: 'black', textAlign: 'center' }} onClick={() => props.logout()}>
                        Sair
                    </div>
                </Link>
            </div>
        </div>
    )
}

export default TopBarView